import React from "react";
import { View, Text, TouchableOpacity, Image, ImageBackground } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import BottomSheet, { BottomSheetScrollView } from "@gorhom/bottom-sheet";

function getFriendsRatingBadge(averageRating) {
  if (!averageRating) return null;
  if (averageRating >= 4.1) return { emoji: "🤤", label: "Crave" };
  if (averageRating >= 3.0) return { emoji: "😌", label: "Solid" };
  return { emoji: "🫢", label: "Toss" };
}

function NearbyRestaurantSheet(
  {
    snapPoints,
    nearbyRestaurant,
    friendsAverageRatings = {},
    onCheckIn,
    onClose,
    insets = { bottom: 0 },
  },
  ref
) {
  return (
    <BottomSheet
      ref={ref}
      enablePanDownToClose
      snapPoints={snapPoints}
      enableOverDrag={false}
      enableDynamicSizing={false}
      index={-1}
      detached={true}
      style={{ zIndex: 30, elevation: 30 }}
      enableContentPanningGesture={true}
      handleIndicatorStyle={{ opacity: 0, height: 0 }}
      handleComponent={() => (
        <View style={{ paddingTop: 10, paddingBottom: 10 }}>
          <View
            style={{
              width: 40,
              height: 4,
              backgroundColor: "#ccc",
              borderRadius: 2,
              alignSelf: "center",
            }}
          />
        </View>
      )}
      onClose={onClose}
    >
      {nearbyRestaurant && (
        <BottomSheetScrollView
          contentContainerStyle={{
            paddingHorizontal: 16,
            paddingTop: 16,
            paddingBottom: 100 + insets.bottom,
          }}
          showsVerticalScrollIndicator={false}
        >
          <View style={{ marginBottom: 8 }}>
            <Text
              style={{
                fontSize: 18,
                fontFamily: "AbhayaLibre_700Bold, serif",
                color: "#000000",
              }}
            >
              You're nearby!
            </Text>
          </View>

          <View style={{ marginBottom: 12, borderRadius: 12, overflow: "hidden", height: 100 }}>
            {nearbyRestaurant.imgUrl || nearbyRestaurant.thumbnail ? (
              <Image
                source={{ uri: nearbyRestaurant.thumbnail || nearbyRestaurant.imgUrl }}
                style={{ width: "100%", height: "100%" }}
                resizeMode="cover"
              />
            ) : (
              <ImageBackground
                source={require("../../../assets/nonDisgoPartnerMembershipCard.jpg")}
                style={{ width: "100%", height: "100%" }}
                imageStyle={{ borderRadius: 12 }}
              />
            )}
          </View>

          <View style={{ backgroundColor: "#F9FAFB", borderRadius: 12, padding: 12, marginBottom: 12 }}>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <View
                style={{
                  width: 40,
                  height: 40,
                  backgroundColor: "#713F12",
                  borderRadius: 20,
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: 8,
                }}
              >
                <Ionicons name="location" size={20} color="white" />
              </View>
              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontSize: 18,
                    fontFamily: "AbhayaLibre_700Bold, serif",
                    color: "#000000",
                    marginBottom: 4,
                  }}
                >
                  {nearbyRestaurant.name}
                </Text>
                {friendsAverageRatings[nearbyRestaurant._id]?.averageRating ? (() => {
                  const ratingBadge = getFriendsRatingBadge(
                    friendsAverageRatings[nearbyRestaurant._id].averageRating
                  );
                  return ratingBadge ? (
                    <Text
                      style={{
                        fontSize: 14,
                        fontFamily: "AbhayaLibre_400Regular, serif",
                        color: "#374151",
                        marginTop: 4,
                      }}
                    >
                      {ratingBadge.emoji} {ratingBadge.label} (
                      {friendsAverageRatings[nearbyRestaurant._id].averageRating.toFixed(1)}
                      ) from friends
                    </Text>
                  ) : null;
                })() : (
                  <Text
                    style={{
                      fontSize: 14,
                      fontFamily: "AbhayaLibre_400Regular, serif",
                      color: "#6B7280",
                      marginTop: 4,
                    }}
                  >
                    No friends rated yet
                  </Text>
                )}
              </View>
            </View>
          </View>

          <View style={{ flexDirection: "row", marginBottom: 16 }}>
            <TouchableOpacity
              onPress={onClose}
              style={{
                flex: 1,
                backgroundColor: "#D1D5DB",
                borderRadius: 8,
                paddingVertical: 12,
                alignItems: "center",
                marginRight: 6,
              }}
            >
              <Text style={{ color: "#374151", fontFamily: "AbhayaLibre_700Bold, serif" }}>Not Now</Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => {
                onCheckIn(nearbyRestaurant._id);
                onClose();
              }}
              style={{
                flex: 1,
                backgroundColor: "#713F12",
                borderRadius: 8,
                paddingVertical: 12,
                alignItems: "center",
                marginLeft: 6,
              }}
            >
              <Text style={{ color: "#FFFFFF", fontFamily: "AbhayaLibre_700Bold, serif" }}>Share Bite</Text>
            </TouchableOpacity>
          </View>
        </BottomSheetScrollView>
      )}
    </BottomSheet>
  );
}

export default React.forwardRef(NearbyRestaurantSheet);
